import axios from "../_helpers/axiosinstance";
import { getApiEndpoint, Endpoint } from "../nhd-config";

const getEndpoint = () => getApiEndpoint(Endpoint.Onboarding);

const onboarding = async (params) => {
  const response = await axios.post(
    getEndpoint(),
    {
      firstname: params.firstname || undefined,
      surname: params.surname || undefined,
      email: params.email || undefined,
      organisation: params.organisation || undefined,
      telNo: params.telNo || undefined,
    }
  );
  // const data = handleResponse(response);
  // return data;
  return response;
};

const OnboardingService = {
  onboarding,
};

export default OnboardingService;
